import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StepsService } from '../../../services/steps.service';
import { IInitializePasswordRequest } from '../../../classes/initialize-password';
import { AppSettings } from '../../../app.settings';
import {
	ICheckUsernameAvailabilityRequest,
	ICreateApplicationRequest,
} from '../../../classes/existing-onboarding-customer/requests';
import { CreateApplicationResponse } from '../../../classes/existing-onboarding-customer/responses';

@Component({
	selector: 'create-password-container',
	template: require('./create-password-container.component.html'),
})
export class CreatePasswordContainerComponent {
	@Output() EmitIsValidForm = new EventEmitter();
	@Output() onTermsUpdated = new EventEmitter<boolean>();
	@Input() initRequest: IInitializePasswordRequest;
	@Input() isNewUser: boolean;

	@Input() isOnboardingFlow = false;
	@Input() ibUsernameRequest: string;
	@Input() appCreateAppResponse: CreateApplicationResponse;
	@Input() public isExistingCustomer = false;
	@Input() createAppRequest: ICreateApplicationRequest;
	@Input() hasAcceptTerms: boolean = false;
	@Input() public isLoginBigModalEnabled: boolean = false;

	constructor(public stepsService: StepsService) {}

	isValidForm(event: any): void {
		this.EmitIsValidForm.emit(event);
	}
	toggleTerms(event: boolean): void {
		this.onTermsUpdated.emit(event);
	}
}
